import { reactive, computed } from 'vue';

import { useHead } from '@vueuse/head';

import { useRoute } from 'vue-router';
// import { useRoute } from 'vue-router';

const defaultData = {
  title:
    '{titleFragment} | Point Music | 全球最大亞洲東方中國音樂 | 版權音樂庫 | 音樂授權 | 廣告配樂 | 商業影片 | 背景音樂 | 作曲 | 免費諮詢 | Point Culture | Pointgroup',
  normalTitle:
    '{titleFragment} | 音韶文化',
  meta: [],
};

const defaultDescription = {
  name: 'description',
  content:
    '音韶文化獨家代理全球各大品牌版權音樂及中國音樂，專為電影、電視、廣告、遊戲及各類影片配樂等專業用途製作，適合專業及個人媒體工作者。百萬首音樂庫免費試聽，中文化介面操作，實用會員功能: 如影音結合體會及選曲記錄。多樣化音樂風格，分類清楚，搜尋快速，授權完整。',
};

const exploreMappingData = {
  themes: {
    title: '主題 | 音韶文化 | 發掘靈感',
    description: '探索音樂 | 發掘我們精心策劃的主題，為您的想像帶來無限靈感。',
  },
  moods: {
    title: '氣氛 | 音韶文化 | 襯托氛圍',
    description: '探索音樂 | 跟著感覺走，讓音樂幫你說話，挑選最佳氛圍。',
  },
  genres: {
    title: '曲風 | 音韶文化 | 音有盡有',
    description: '探索音樂 | 依照曲風來尋找各類音樂，內容一應俱全。',
  },
  playlists: {
    title: '歌單 | 音韶文化 | 精心挑選',
    description: '探索音樂 | 每個歌單都經過精挑細選，以打造最符合您心境的旋律。',
  },
  albums: {
    title: '專輯 | 音韶文化 | 音樂家創作結晶',
    description: '探索音樂 | 數十萬張專輯，集結自各國才華音樂家的創作結晶。',
  },
  labels: {
    title: '品牌 | 音韶文化 | 各有特色',
    description: '探索音樂 | 尋找音樂，從認識各家知名音樂品牌開始。',
  },
};

const ogDefaultMetaList = {
  title: {
    property: 'og:title',
    content:
      '音韶文化 | Point Music | 全球最大亞洲東方中國音樂 | 版權音樂庫 | 音樂授權 | 廣告配樂 | 商業影片 | 背景音樂 | 作曲 | 免費諮詢 | Point Culture | Pointgroup',
  },
  description: {
    property: 'og:description',
    content:
      '音韶文化獨家代理全球各大品牌版權音樂及中國音樂，專為電影、電視、廣告、遊戲及各類影片配樂等專業用途製作，適合專業及個人媒體工作者。百萬首音樂庫免費試聽，中文化介面操作，實用會員功能: 如影音結合體會及選曲記錄。多樣化音樂風格，分類清楚，搜尋快速，授權完整。',
  },
  image: {
    property: 'og:image',
    content: `${document.location.origin}/static/logo/logo.png`,
  },
  url: {
    property: 'og:url',
    content: document.location.origin,
  },
};

export default (isHome) => {
  const route = useRoute();
  const siteData = reactive({
    title: '',
  });

  const implicitMetaList = (ogList = ['title', 'description', 'image', 'url']) => ogList.reduce((list, ogName) => {
    if (ogDefaultMetaList[ogName]) {
      list.push(ogDefaultMetaList[ogName]);
    }

    return list;
  }, []);

  const setTitleFragment = () => {
    const isStaticPage = [
      'front-about-us',
      'front-contact',
      'licensing',
      'licensing-terms',
      'licensing-privacy',
      'licensing-cookies',
      'sign-in',
      'sign-up',
      'password-recovery',
      'validate',
      'reset-password',
    ].includes(route.name);

    const isAuthPage = [
      'my-profile-personal-details',
      'my-profile-my-prefer',
      'my-profile-change-password',
      'my-profile-customer-service',
      'my-music-playlists',
      'my-music-search-history',
      'my-music-play-history',
      'my-music-download-history',
      'my-music-my-note',
      'my-music-preview-tool',
    ].includes(route.name);

    if (isStaticPage) {
      siteData.title = defaultData.title.replace('{titleFragment}', route.meta.title);
      siteData.meta = [defaultDescription, ...implicitMetaList()];
      return;
    }

    if (isAuthPage || route.name === 'search') {
      siteData.title = defaultData.normalTitle.replace('{titleFragment}', route.meta.title);
      siteData.meta = [defaultDescription, ...implicitMetaList()];
      return;
    }

    if (route.name === 'explore-type') {
      siteData.title = exploreMappingData[route.params.type].title;
      siteData.meta = [
        {
          name: 'description',
          content: exploreMappingData[route.params.type].description,
        },
        {
          property: 'og:title',
          content: exploreMappingData[route.params.type].title,
        },
        {
          property: 'og:description',
          content: exploreMappingData[route.params.type].description,
        },
        ...implicitMetaList(['image', 'url']),
      ];

      return;
    }

    siteData.title = defaultData.title.replace('{titleFragment}', '音韶文化');
    siteData.meta = [defaultDescription, ...implicitMetaList()];
  };

  const updateDynamicMeta = (metaList) => {
    const renderMetaList = metaList.reduce((list, item) => {
      if (['title', 'description'].includes(item.name)) {
        list.push(item);
        list.push({
          property: `og:${item.name}`,
          content: item.content,

        });
      }

      if (item.name === 'image') {
        list.push({
          property: `og:${item.name}`,
          content: item.content,

        });
      }

      return list;
    }, []);

    const title = metaList.find((item) => item.name === 'title').content;

    siteData.title = title;
    siteData.meta = renderMetaList;
    siteData.meta = [...renderMetaList, ...implicitMetaList(['url'])];
  };

  const updateMeta = () => {
    setTitleFragment();
  };

  const handleMeta = () => {
    useHead({
      title: computed(() => siteData.title),
      meta: computed(() => siteData.meta),
    });

    if (isHome) {
      updateMeta();
    }
  };

  // watch(routeName, (newVal) => {
  //   updateMeta(newVal);
  // }, { immediate: true });

  return {
    handleMeta,
    updateMeta,
    updateDynamicMeta,
  };
};
